// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/edge_sketch.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'edge_sketchPixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform highp sampler2D depthSampler;
uniform vec2 inverseDepthDimensions;
uniform mat4 inverseProjectionMatrix;
vec3 viewSpacePositionFromDepth(float z, float u, float v)
{
vec4 vProjectedPos = vec4(vec3(u, v, z) * 2.0 - 1.0, 1.0);
vec4 viewspacePosition = inverseProjectionMatrix * vProjectedPos;
return viewspacePosition.xyz / viewspacePosition.w;
}
vec3 improvedViewSpaceNormalFromNeighbours(vec3 center, float depthCenter) {
vec2 right = (vUV + (vec2(1,0) * inverseDepthDimensions));
vec2 up = (vUV + (vec2(0,1) * inverseDepthDimensions));
vec2 down = (vUV + (vec2(0,-1) * inverseDepthDimensions));
vec2 left = (vUV + (vec2(-1,0) * inverseDepthDimensions));
float depthRight = texture2D(depthSampler, right).r;
float depthUp = texture2D(depthSampler, up).r;
float depthDown = texture2D(depthSampler, down).r;
float depthLeft = texture2D(depthSampler, left).r;
bool useDown = abs(depthDown - depthCenter) < abs(depthUp - depthCenter);
bool useLeft = abs(depthLeft - depthCenter) < abs(depthRight - depthCenter);
if (useDown && useLeft) {
vec3 pDown = viewSpacePositionFromDepth(depthDown, down.x, down.y);
vec3 pLeft = viewSpacePositionFromDepth(depthLeft, left.x, left.y);
return normalize(cross(normalize(pLeft - center), normalize(pDown - center)));
} else if (useDown) {
vec3 pDown = viewSpacePositionFromDepth(depthDown, down.x, down.y);
vec3 pRight = viewSpacePositionFromDepth(depthRight, right.x, right.y);
return normalize(cross(normalize(pDown - center), normalize(pRight - center)));
} else if (!useDown && useLeft) {
vec3 pUp = viewSpacePositionFromDepth(depthUp, up.x, up.y);
vec3 pLeft = viewSpacePositionFromDepth(depthLeft, left.x, left.y);
return normalize(cross(normalize(pUp - center), normalize(pLeft - center)));
} else {
vec3 pRight = viewSpacePositionFromDepth(depthRight, right.x, right.y);
vec3 pUp = viewSpacePositionFromDepth(depthUp, up.x, up.y);
return normalize(cross(normalize(pRight - center), normalize(pUp - center)));
}
}
float remap(float a, float b, float x) {
return clamp((x - a) / (b - a), 0.0, 1.0);
}
void main() {
float pixelDepthValue = texture2D(depthSampler, vUV).r;
vec3 viewSpacePosition = viewSpacePositionFromDepth(pixelDepthValue, vUV.x, vUV.y);
vec3 viewSpaceNormal = improvedViewSpaceNormalFromNeighbours(viewSpacePosition, pixelDepthValue);
vec2 sobelDot = vec2(0.0);
vec3 V = vec3(0, 0, -1);
const float sobelNorm = 0.25;
const float s0 = 1.0;
const float s1 = 3.0;
const float s2 = 9.0;
const float[] sobelKernel = float[](
-s1, -s1, -s2, -s1, -s1,
-s0, -s0, -s1, -s0, -s0,
0.0, 0.0, 0.0, 0.0, 0.0,
s0,  s0,  s1,  s0,  s0,
s1,  s1,  s2,  s1,  s1
);
const float minDot = sin(30.0 / 180.0 * 3.14159265354);
for (int x = 0; x < 5; x++) {
for (int y = 0; y < 5; y++) {
vec2 uv = vUV + vec2(x - 2, y - 2) * inverseDepthDimensions;
float z = texture2D(depthSampler, uv).r;
vec3 P = viewSpacePositionFromDepth(z, uv.x, uv.y);
vec3 D = P - viewSpacePosition;
float L = length(D);
float cosD = dot(viewSpaceNormal, D / L);
float d = remap(minDot * abs(dot(V, viewSpaceNormal)), 1.0, abs(cosD));
vec2 K = vec2(sobelKernel[x * 5 + y], sobelKernel[y * 5 + x]);
sobelDot += L * d * K;
}
}
float sD = abs(sobelDot.x) + abs(sobelDot.y);
float sobel = smoothstep(0.015, 0.02, sD * sobelNorm);
gl_FragColor.rgb = 32.0 * vec3(clamp(1.0 - sobel, 0.0, 1.0));
gl_FragColor.a = 1.0;
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const edge_sketchPixelShader = { name, shader };
//# sourceMappingURL=edge_sketch.fragment.js.map